import React from 'react';
import { cn } from '../../lib/utils';

const buttonVariants = {
  default: 'bg-primary text-white shadow-sm shadow-primary-900/15 hover:bg-primary-700',
  secondary: 'bg-charcoal-900 text-white shadow-sm shadow-charcoal-900/15 hover:bg-charcoal-800',
  success: 'bg-success text-white shadow-sm shadow-success-900/15 hover:bg-success-700',
  destructive: 'bg-alert text-white shadow-sm shadow-alert-900/15 hover:bg-alert-700',
  outline: 'border border-neutral-300 bg-white text-charcoal-700 shadow-sm hover:border-primary-300 hover:bg-primary-50 hover:text-primary-800',
  ghost: 'text-charcoal-600 hover:bg-neutral-200 hover:text-charcoal-900',
  subtle: 'bg-primary-50 text-primary-800 hover:bg-primary-100',
};

const buttonSizes = {
  xs: 'h-7 px-2.5 text-xs',
  sm: 'h-9 px-3 text-sm',
  default: 'h-10 px-4 text-sm',
  lg: 'h-12 px-6 text-base',
};

export const Button = React.forwardRef(function Button({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  children,
  ...props
}, ref) {
  const buttonClasses = cn(
    'inline-flex min-w-0 items-center justify-center gap-2 rounded-xl font-semibold transition-all duration-200',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-50',
    buttonVariants[variant] || buttonVariants.default,
    buttonSizes[size] || buttonSizes.default,
    className
  );

  if (asChild) {
    if (!React.isValidElement(children)) {
      return null;
    }

    return React.cloneElement(children, {
      ...props,
      className: cn(buttonClasses, children.props.className, props.className),
      ref
    });
  }

  return (
    <button
      ref={ref}
      className={buttonClasses}
      {...props}
    >
      {children}
    </button>
  );
});